import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import BannerHome from "./BannerHome"
import AppCarousel from "@components/AppCarousel"
import Highlights from "./Highlights"
import Message from "@components/Message"
import ProblemStatement from "./ProblemStatement"
import FAQ from "@components/FAQ"
import CTASignUpLong from "@components/CTASignUpLong"
import Footer from "@components/Footer"
import Wrapper from "@components/Wrapper"
import "@styles/custom-bootstrap.scss"
import "@styles/global.scss"
import styles from "./home.module.scss"

const Home = props => {
  return (
    <div>
      <EngineIDNavBar />
      <BannerHome />
      <div className={"container-fluid"}>
        <div className={"row maxWidth"}>
          <Highlights />
          <Message />
          <AppCarousel />
          <ProblemStatement />
          { /* we are sharing the faq section, between this page
              and the faqs page, so we need to add some code here since
              the layouts are different. */ }
          <section
            id="faq-section"
            className={styles.section + " container-fluid bg-light-gray"}
          >
            <div className="row ml-0 mr-0">
              <Wrapper className="w-100" gap="outer">
                <FAQ />
              </Wrapper>
            </div>
          </section>
        </div>
      </div>
      <CTASignUpLong />
      <Footer />
    </div>
  )
}

export default Home
